import React from 'react';
import { HeadingRegular, BodyR } from '@pensionbee/honeypot-ui';
import { ReceivedGuidanceOption } from '../GuidanceOptions/ReceivedGuidanceOption';
import { DeclineAppointmentOption } from '../GuidanceOptions/DeclineAppointmentOption';
import { CustomerPhoneBookingOption } from '../GuidanceOptions/CustomerPhoneBookingOption';
import { CustomerWebBookingOption } from '../GuidanceOptions/CustomerWebBookingOption';
import { PensionBeeBookingOption } from '../GuidanceOptions/PensionBeeBookingOption';
import { StageProps } from '../../config/StrongerNudgeConfig';

export const GuidanceConfirmationPartial = ({
  onSubmit,
}: {
  onSubmit: StageProps['onSubmit'];
}) => {
  return (
    <>
      <HeadingRegular className="pb-28">Please confirm</HeadingRegular>
      <div className="flex flex-col gap-20 pb-28">
        <BodyR>
          We just need to remind you of the importance of taking Pension Wise
          guidance, the purpose of which is to help you make an informed
          decision about what to do with your pension savings, including the
          different options available to you. The guidance delivered by Pension
          Wise is a free government service, at an appointment with an
          independent specialist. You can also obtain regulated financial advice
          at your own cost.
        </BodyR>
        <BodyR>
          Please confirm below whether you&apos;ve received the guidance, need a
          new appointment, or want to opt out.
        </BodyR>
      </div>
      <ReceivedGuidanceOption onSubmit={onSubmit} />
      <DeclineAppointmentOption onSubmit={onSubmit} isConfirmationScreen />
      <CustomerPhoneBookingOption onSubmit={onSubmit} isConfirmationScreen />
      <CustomerWebBookingOption onSubmit={onSubmit} isConfirmationScreen />
      <PensionBeeBookingOption onSubmit={onSubmit} isConfirmationScreen />
    </>
  );
};
